import { lazy } from "react";
// Patient Map — mapa de pacientes, detalle clínico y Otros Seguros.
const PatientMapPage = lazy(() => import("./PatientMapPage"));
const PatientMap = lazy(() => import("./PatientMap"));
const OtherInsuranceDetailPage = lazy(() => import("./OtherInsurance/OtherInsuranceDetailPage"));
export const patientMapRoutes = [
  { path: "/patient-map", element: <PatientMapPage /> },
  { path: "/PatientMap", element: <PatientMap /> },
  { path: "/patient-detail/:patientId", element: <PatientMapPage /> },
  { path: "/patient-map/other-insurance/:cipId", element: <OtherInsuranceDetailPage /> },
];

export { PatientMapPage, PatientMap, OtherInsuranceDetailPage };
